import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd76efc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head-cell data-column" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "arrow" }, null, -1))
const _hoisted_5 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldGrid = _resolveComponent("FieldGrid")!
  const _component_TabularField = _resolveComponent("TabularField")!

  return (_openBlock(), _createBlock(_component_TabularField, {
    class: "complex-table-field-control",
    property: _ctx.property,
    onExecute: _cache[1] || (_cache[1] = c => _ctx.$emit('execute', c))
  }, {
    "table-header": _withCtx(() => [
      _createElementVNode("th", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.property.name), 1)
        ])
      ])
    ]),
    "table-row": _withCtx(({ key, row }) => [
      _createElementVNode("td", {
        class: _normalizeClass(['data-column', { collapsed: _ctx.property.collapsed.get(key) }])
      }, [
        _createElementVNode("div", {
          class: "data-region-header",
          onClick: ($event: any) => (_ctx.onCollapse(key))
        }, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summarize(_ctx.property.layout.summary, row), (item, i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: i,
                class: _normalizeClass(item.format)
              }, _toDisplayString(item.text), 3))
            }), 128))
          ])
        ], 8, _hoisted_3),
        (!_ctx.property.collapsed.get(key))
          ? (_openBlock(), _createBlock(_component_FieldGrid, {
              key: 0,
              class: "data-region-body",
              rows: _ctx.property.layout.rows,
              cols: _ctx.property.layout.cols,
              properties: row,
              onExecute: _cache[0] || (_cache[0] = c => _ctx.$emit('execute', c))
            }, null, 8, ["rows", "cols", "properties"]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 8, ["property"]))
}